var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M10.9975 8.99994L17.0892 2.92244C17.3559 2.65567 17.5058 2.29386 17.5058 1.9166C17.5058 1.53934 17.3559 1.17753 17.0892 0.910771C16.8224 0.644007 16.4606 0.494141 16.0833 0.494141C15.7061 0.494141 15.3443 0.644007 15.0775 0.910771L9 7.00244L2.9225 0.910771C2.65573 0.644007 2.29392 0.494141 1.91666 0.494141C1.5394 0.494141 1.17759 0.644007 0.910831 0.910771C0.644067 1.17753 0.494201 1.53934 0.494201 1.9166C0.494201 2.29386 0.644067 2.65567 0.910831 2.92244L7.0025 8.99994L0.910831 15.0774C0.778049 15.2091 0.672657 15.3658 0.600735 15.5385C0.528813 15.7111 0.491783 15.8963 0.491783 16.0833C0.491783 16.2703 0.528813 16.4555 0.600735 16.6281C0.672657 16.8007 0.778049 16.9574 0.910831 17.0891C1.04253 17.2219 1.19921 17.3273 1.37185 17.3992C1.54448 17.4711 1.72965 17.5082 1.91666 17.5082C2.10368 17.5082 2.28885 17.4711 2.46148 17.3992C2.63412 17.3273 2.7908 17.2219 2.9225 17.0891L9 10.9974L15.0775 17.0891C15.2092 17.2219 15.3659 17.3273 15.5385 17.3992C15.7111 17.4711 15.8963 17.5082 16.0833 17.5082C16.2703 17.5082 16.4555 17.4711 16.6281 17.3992C16.8008 17.3273 16.9575 17.2219 17.0892 17.0891C17.2219 16.9574 17.3273 16.8007 17.3993 16.6281C17.4712 16.4555 17.5082 16.2703 17.5082 16.0833C17.5082 15.8963 17.4712 15.7111 17.3993 15.5385C17.3273 15.3658 17.2219 15.2091 17.0892 15.0774L10.9975 8.99994Z",
    fill: "#303949"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.23badb99e60dc4169e868bf13d5252d3.svg";
export { ForwardRef as ReactComponent };